import { indCustQuotOtpId } from './indCustQuotOtp-dto';

export class OTP {
    otp: number;
    indCustQuotOtpId: indCustQuotOtpId;
    validOtp: boolean;
    quotStatusId: string;
    quotationNumber: string;

    constructor() {
        this.indCustQuotOtpId = new indCustQuotOtpId();
    }
}